import salesPlatformColumnLoading from "@assets/sales-v3-platform-loading-cell.gif";

export const NameLoaderCell = () => {
  return (
    <div className="h-full flex items-center px-2">
      <img
        src={salesPlatformColumnLoading}
        alt="Loading table"
        className="h-7"
      />
    </div>
  );
};
